

@if (profileService.profile$ | async; as profile) {
  <div class="dropdown" ngbDropdown container="body">
    <button class="btn-account d-none d-md-flex" type="button" ngbDropdownToggle aria-haspopup="true" aria-expanded="true">
      <span class="account-summary pr-lg-4 d-none d-lg-block">
        <span class="account-name">{{ profile.biodata.displayName }}</span>
        @if (auth.loginState != 5 && (auth.token.payload && auth.token.payload.AudiencesOrig && auth.token.payload.AudiencesOrig != auth.token.payload.Audiences)) {
          <span class="account-description">
            <i class="fas fa-user-secret"></i> {{this.auth.token.payload.AudienceUi}} Audience
          </span>
        } @else {
          <ng-template [ngTemplateOutlet]="showDescription"></ng-template>
        }
        <!--<ng-template #showDescription>
        <span class="account-description">{{ //profile.biodata.description }}</span>
      </ng-template>-->
    </span>
    @if (auth.isSpoofing) {
      <span>
        <i class="fas fa-user-secret fa-2x" (click)="profileService.unspoof()"></i>
      </span>
    }
    @if (!auth.isSpoofing) {
      <span class="user-avatar">
        <img #profileImg
          src="{{profile.biodata.photoUrl}}"
          alt="{{profile.biodata.displayName}}"
          (error)="profileImg.src = profile.biodata.failedPhotoUrl">
        </span>
      }
    </button>
    <div class="dropdown-arrow dropdown-arrow-left"></div>
    <div ngbDropdownMenu class="dropdown-menu profile-dropdown-menu">
      <h6 class="dropdown-header d-none d-md-block d-lg-none">{{ profile.biodata.displayName }}</h6>
      <a class="dropdown-item" routerLink="profile" (click)="toggle()">
        <span class="dropdown-icon fas fa-user"></span> Profile
      </a>
      @if (this.isEditor) {
        <a class="dropdown-item" href="http://mykecontent.kenan-flagler.unc.edu/wp-admin">
          <span class="dropdown-icon fas fa-edit"></span> EDITOR
        </a>
      }
      @if (this.isEditor) {
        <a class="dropdown-item" (click)="utility.flushServerCache()" style="cursor:pointer">
          <span class="dropdown-icon fas fa-recycle"></span> Refresh content
        </a>
      }
      @if (this.isInspector) {
        <a class="dropdown-item" (click)="toggleInspector()">
          <span class="dropdown-icon fas fa-bug"></span> INSPECTOR
        </a>
      }
      <!--<a class="dropdown-item" href="mailto:appdevsupport@kenan-flagler.unc.edu?subject=MyKE Feedback">
      <span class="dropdown-icon far fa-comment"></span> Feedback
    </a>-->
    @if (auth.hasFeature('MykeV1') && auth.hasFeature('MykeV2')) {
      <a class="dropdown-item" style="cursor:pointer" (click)="selectVersion(profile)">
        <span class="far" [ngClass]="profile.version == 2 ? 'fa-arrow-circle-down' : 'fa-arrow-circle-up'"></span> Switch to V{{profile.version == 2 ? '1' : '2'}}
      </a>
    }
    <a class="dropdown-item" routerLink="login">
      <span class="dropdown-icon fas fa-sign-out-alt"></span> Logout
    </a>
    @if (auth.isSpoofing) {
      <a class="dropdown-item" style="cursor:pointer" (click)="auth.unspoof()">
        <span class="dropdown-icon fas fa-user-secret"></span> Unspoof
      </a>
    }
    @if (auth.loginState != 5 && (auth.token.payload.AudiencesOrig && auth.token.payload.AudiencesOrig != auth.token.payload.Audiences)) {
      <a class="dropdown-item" style="cursor:pointer" (click)="auth.reaudience(auth.token.payload.AudiencesOrig);">
        <span class="dropdown-icon fas fa-user-secret"></span> Revert Audience
      </a>
    }
  </div>
</div>
} @else {
}

